/** @jsx jsx */
import { Box, Image, jsx } from "theme-ui"
import Heading from "./heading";
import Text from "./text";

function ArtworkCard({art, hideLocation, fullWidth,}: {art: object; hideLocation?: boolean; fullWidth?: boolean;}) {
    return (
        <Box>
            <div style={{borderBottom: '1px solid rgba(0,0,0,0.2)',}}>
                <Image sx={{
                    display: 'block', 
                    width: '100%', 
                    height: ['auto', '129px'], 
                    objectFit: 'cover',
                    }} 
                    width={500} 
                    src={art.image_url} 
                />
            </div>
            <div sx={{
                flex: 1,
                py: 2,
                px: fullWidth ? 0 : 2,
            }}>
                <Heading xSmall>{art.title}</Heading>
                <Text dark small marginBelow>{art.artist}</Text>
                {!hideLocation && <Text dark small>{art.location}</Text>}
            </div>
        </Box>
    )
}

export default ArtworkCard